import VirtualProjectTable from "@/app/app-shared/virtual-project/table";

export default function VirtualProjectListingPage(){

    return (<div className={'mt-4'}>
        <VirtualProjectTable/>
    </div>)
}